import { render } from "./_okrElementsView.vue?vue&type=template&id=d2691eb8&scoped=true"
import script from "./_okrElementsView.vue?vue&type=script&lang=js"
export * from "./_okrElementsView.vue?vue&type=script&lang=js"

import "./_okrElementsView.vue?vue&type=style&index=0&id=d2691eb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2691eb8"]])

export default __exports__